import React, { useState, useEffect } from 'react'
import {
  FormGroup,
  ControlLabel,
  FormControl,
  Radio,
  RadioGroup,
  Row,
  Col,
  DatePicker,
  Uploader,
  Icon,
  Table,
  ButtonToolbar,
  ButtonGroup,
  Button,
  IconButton,
  Message,
  Input,
} from 'rsuite'
import classNames from 'classnames'
import {
  isValidators,
  isRequired,
  getMaxLengthData,
  requiredFiled,
  isImageOrPdf,
  isSupportFileType,
} from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../message/errorMessage/ErrorMessage'
import { DATE_FORMAT, LOCAL_DAY_TH, DATE_PICKER_FORMAT } from '../../../constants/date'
// import './styles.less'
import moment from 'moment'
import AppContext from '../../../context/AppContext'
import { isEmpty } from 'lodash-es'
import './styles.less'
import ConfirmWidget from '../../../widgets/confirm/ConfirmWidget'

export default function ReviewSummaryForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  reset,
  clearErrors,
  isMulti,
  isSubProject,
  disabledForm,
  disableTableFiles,
  onDelete,
  isDeleteError,
  onPreview,
  onDownload,
  isRefreshSchema = false,
}) {
  const { Column, HeaderCell, Cell } = Table
  const { theme } = React.useContext(AppContext)
  const [schema, setSchema] = useState(_schema)
  const [reviewResult, setReviewResult] = useState(_schema?.reviewResult?.value)
  const [summarizeReviewResult, setSummarizeReviewResult] = useState(
    _schema?.summarizeReviewResult?.value
  )
  // const [reviewerFilter, setReviewerFilter] = useState(
  //   isEmpty(_schema?.reviewerFilter?.value) ? 3 : parseInt(_schema?.reviewerFilter?.value, 10)
  // )
  const [reviewerFilter, setReviewerFilter] = useState(_schema?.reviewerFilter?.value)

  const [uploadfileList, setUploadfileList] = useState([])
  const [supportFileError, setSupportFileError] = useState(false)
  const [isOverSize, setIsOverSize] = useState(false)
  const [isNotSupportType, setIsNotSupportType] = useState(false)

  const [fileList, setFileList] = useState([])
  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false)
  const [fileId, setFileId] = useState()

  const defaultSupportType = '.jpg, .jpeg, .png, .pdf'
  const defaultMaxFileSize = 5

  useEffect(() => {
    setFileId()
    setIsShowConfirmDelete(false)
  }, [isDeleteError])

  useEffect(() => {
    console.log('isRefreshSchema ', isRefreshSchema)
    isRefreshSchema && setUploadfileList([])
  }, [isRefreshSchema])

  useEffect(() => {
    setFileList(_schema.reviewFile?.value ? _schema.reviewFile?.value : [])

    setReviewerFilter(
      isEmpty(_schema?.reviewerFilter?.value) ? 3 : parseInt(_schema?.reviewerFilter?.value, 10)
    )
    setSchema(_schema)

    setReviewResult(_schema?.reviewResult?.value)
    setSummarizeReviewResult(_schema?.summarizeReviewResult?.value)
  }, [_schema])

  useEffect(() => {
    if (isSubProject) {
      setReviewerFilter(_schema?.reviewerFilter?.value || '0')
      setValue(schema.reviewerFilter.name, _schema?.reviewerFilter?.value || '0')
    }
  }, [_schema])

  const handleDeleteFile = (fileId) => {
    setFileId(fileId)
    setIsShowConfirmDelete(true)
  }

  const handleOnConfirmDelete = () => {
    console.log('handleOnConfirmDelete')
    onDelete(fileId)
  }

  const onUploaderChange = (props, fileList) => {
    if (isEmpty(fileList)) {
      props.onChange(undefined)
      setUploadfileList(fileList)
      setSupportFileError(false)
    } else {
      let file = fileList[fileList.length - 1]

      let isSupportSize = true
      let isSupportType = isSupportFileType(
        file?.blobFile.type,
        schema?.reviewFile?.fileType || defaultSupportType
      )

      if (schema?.reviewFile?.fileSize && schema?.reviewFile?.fileSize > 0) {
        isSupportSize = file?.blobFile.size <= schema?.reviewFile?.fileSize * 1024 * 1024
        setIsOverSize(!isSupportSize)
      } else {
        defaultMaxFileSize
        isSupportSize = file?.blobFile.size <= defaultMaxFileSize * 1024 * 1024
        setIsOverSize(!isSupportSize)
      }

      setIsNotSupportType(!isSupportType)

      if (!file || (isSupportType && isSupportSize)) {
        props.onChange(fileList)
        setUploadfileList(fileList)
        setSupportFileError(false)
      } else {
        fileList.splice(fileList.length - 1, 1)
        setUploadfileList(fileList)
        setSupportFileError(true)
      }
    }
  }

  return (
    <>
      {isSubProject && (
        <>
          <Row style={{ marginBottom: '10px' }}>
            <Col xs={24} sm={8} md={6} lg={6} style={{ marginTop: '10px', width: 220 }}>
              <ControlLabel
                className={classNames(
                  'style-text-lable',
                  isRequired(schema.dateOfScrutinize.validators) && 'required'
                )}
              >
                {schema.dateOfScrutinize.label}
              </ControlLabel>
              <ErrorMessage error={errors.dateOfScrutinize} />
              <Controller
                name={schema.dateOfScrutinize.name}
                control={control}
                defaultValue={
                  schema.dateOfScrutinize.value
                    ? moment(schema.dateOfScrutinize.value, DATE_PICKER_FORMAT).toDate()
                    : null
                }
                rules={isValidators(schema.dateOfScrutinize.validators)}
                render={(props) => {
                  return (
                    <DatePicker
                      format="DD/MM/YYYY"
                      locale={LOCAL_DAY_TH}
                      block
                      placement="auto"
                      value={props.value}
                      onChange={(value) => {
                        props.onChange(value)
                      }}
                      disabled={disabledForm}
                    />
                  )
                }}
              />
            </Col>
            <Col xs={24} sm={8} md={6} lg={6} style={{ marginTop: '10px', width: 220 }}>
              <ControlLabel
                className={classNames(
                  'style-text-lable',
                  isRequired(schema.dateOfScrutinizeRes.validators) && 'required'
                )}
              >
                {schema.dateOfScrutinizeRes.label}
              </ControlLabel>
              <ErrorMessage error={errors.dateOfScrutinizeRes} />
              <Controller
                name={schema.dateOfScrutinizeRes.name}
                control={control}
                defaultValue={
                  schema.dateOfScrutinizeRes.value
                    ? moment(schema.dateOfScrutinizeRes.value, DATE_PICKER_FORMAT).toDate()
                    : null
                }
                rules={isValidators(schema.dateOfScrutinizeRes.validators)}
                render={(props) => {
                  return (
                    <DatePicker
                      format="DD/MM/YYYY"
                      locale={LOCAL_DAY_TH}
                      block
                      placement="auto"
                      value={props.value}
                      onChange={(value) => {
                        props.onChange(value)
                      }}
                      disabled={disabledForm}
                    />
                  )
                }}
              />
            </Col>
          </Row>
        </>
      )}

      <ControlLabel
        className={classNames(
          'style-text-lable',
          isRequired(schema.reviewResult.validators) && 'required'
        )}
      >
        {schema.reviewResult.label}
      </ControlLabel>
      <ErrorMessage error={errors.reviewResult} />
      <Input
        name={schema.reviewResult.name}
        defaultValue={reviewResult}
        maxLength={getMaxLengthData(schema.reviewResult.validators)?.value}
        componentClass="textarea"
        placeholder={schema.reviewResult.hint || `ระบุ${schema.reviewResult.label}`}
        inputRef={register(isValidators(schema.reviewResult.validators))}
        onChange={(value) => {
          setReviewResult(value)
        }}
        disabled={schema?.reviewerFilter?.disabled || disabledForm}
      />

      <br />

      {!isMulti && (
        <>
          <ErrorMessage error={errors.reviewerFilter} />

          <Controller
            name={schema.reviewerFilter.name}
            control={control}
            defaultValue={reviewerFilter}
            rule={register(isValidators(schema.reviewerFilter.validators))}
            render={(props) => {
              return (
                <RadioGroup
                  value={reviewerFilter}
                  onChange={(value) => {
                    console.log('value => ', value)
                    props.onChange(value)
                    setReviewerFilter(value)
                  }}
                >
                  {schema.reviewerFilter.options.map((item) => (
                    <Radio
                      key={item.value}
                      value={item.value}
                      disabled={schema.reviewerFilter.disabled || disabledForm}
                    >
                      {item.label}
                    </Radio>
                  ))}
                </RadioGroup>
              )
            }}
          />

          {reviewerFilter == 11 && schema?.summarizeReviewResult && (
            <>
              <ControlLabel
                className={classNames(
                  'style-text-lable',
                  isRequired(schema.summarizeReviewResult.validators) && 'required'
                )}
              >
                {schema.summarizeReviewResult.label}
              </ControlLabel>
              <ErrorMessage error={errors.summarizeReviewResult} />
              <Input
                name={schema.summarizeReviewResult.name}
                defaultValue={summarizeReviewResult}
                maxLength={getMaxLengthData(schema.summarizeReviewResult.validators)?.value}
                componentClass="textarea"
                placeholder={
                  schema.summarizeReviewResult.hint || `ระบุ${schema.summarizeReviewResult.label}`
                }
                inputRef={register(isValidators(schema.summarizeReviewResult.validators))}
                onChange={(value) => {
                  setSummarizeReviewResult(value)
                }}
                disabled={schema?.reviewerFilter?.disabled || disabledForm}
              />
            </>
          )}

          {!isSubProject && (
            <div style={{ marginTop: 20 }}>
              <ControlLabel
                className={classNames(
                  'style-text-lable',
                  isSubProject && isRequired(schema.reviewFile?.validators) && 'required'
                )}
              >
                {schema.reviewFile?.label}
              </ControlLabel>

              <Row style={{ marginTop: 10 }}>
                {supportFileError && (
                  <Message
                    style={{ marginTop: 10, marginBottom: 10 }}
                    closable
                    onClose={() => {
                      setSupportFileError(false)
                    }}
                    showIcon
                    type="error"
                    description={`${
                      isNotSupportType
                        ? `อัพโหลดไฟล์ได้เฉพาะที่รองรับเท่านั้น *** ชนิดที่รองรับ ${
                            schema?.reviewFile?.fileType || defaultSupportType
                          } ***`
                        : ''
                    }  ${
                      isOverSize
                        ? ` ขนาดไฟล์เกิน ${schema?.reviewFile?.fileSize || defaultMaxFileSize} MB `
                        : ''
                    }`}
                  />
                )}

                <Controller
                  name={'file'}
                  control={control}
                  defaultValue={undefined}
                  render={(props) => {
                    return (
                      <Uploader
                        accept={schema?.reviewFile?.fileType || defaultSupportType}
                        draggable
                        autoUpload={false}
                        multiple={true}
                        fileList={uploadfileList}
                        onChange={(fileList) => {
                          onUploaderChange(props, fileList)
                        }}
                      >
                        <div>
                          <div
                            style={{ lineHeight: '50px' }}
                            className={classNames('uploader', `${theme[0]}-background`)}
                          >
                            <Icon size="4x" icon="upload2" />
                            <small className="uploder__text">
                              <p style={{ wordBreak: 'break-word' }}>
                                คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                              </p>
                            </small>
                          </div>
                        </div>
                      </Uploader>
                    )
                  }}
                />
              </Row>

              {fileList.length > 0 && (
                <Row style={{ marginTop: 10 }}>
                  <Table autoHeight={fileList.length < 5} height={300} wordWrap data={fileList}>
                    <Column width={100} align="center" fixed>
                      <HeaderCell>ไฟล์ที่</HeaderCell>
                      <Cell>
                        {(_, index) => {
                          return index + 1
                        }}
                      </Cell>
                    </Column>
                    <Column flexGrow={1} fixed>
                      <HeaderCell>ชื่อไฟล์</HeaderCell>
                      <Cell dataKey="name" />
                    </Column>
                    <Column width={320} align="center" fixed="right">
                      <HeaderCell></HeaderCell>

                      <Cell>
                        {(rowData, index) => {
                          return (
                            <ButtonToolbar>
                              <ButtonGroup>
                                <Button
                                  size="xs"
                                  appearance={'primary'}
                                  color="blue"
                                  onClick={() => {
                                    onPreview(rowData)
                                  }}
                                >
                                  <Icon icon="eye" size="lg" />
                                  {'  '}แสดง
                                </Button>
                                <Button
                                  size="xs"
                                  appearance={'primary'}
                                  onClick={() => {
                                    onDownload(rowData)
                                  }}
                                >
                                  <Icon icon="download2" size="lg" />
                                  {'  '}ดาวน์โหลด
                                </Button>
                                <Button
                                  size="xs"
                                  appearance={'primary'}
                                  color="red"
                                  onClick={() => {
                                    handleDeleteFile(rowData.id)
                                  }}
                                >
                                  <Icon icon="trash" size="lg" />
                                  {'  '}ลบ
                                </Button>
                              </ButtonGroup>
                            </ButtonToolbar>
                          )
                        }}
                      </Cell>
                    </Column>
                  </Table>
                </Row>
              )}

              <ConfirmWidget
                title={`ยืนยันการลบเอกสารแนบ`}
                show={isShowConfirmDelete}
                detail={`ยืนยันการลบเอกสารแนบ `}
                onCancle={() => setIsShowConfirmDelete(false)}
                onConfirm={handleOnConfirmDelete}
              />

              <br />
            </div>
          )}
        </>
      )}

      {/* {isSubProject && (
        <Row>
          <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: '10px' }}>
            <ControlLabel className={classNames(isRequired(attachments.validators) && 'required')}>
              {attachments.label}
            </ControlLabel>
            <ErrorMessage error={errors.attachments} />
            <Controller
              name={attachments.name}
              control={control}
              defaultValue={!isEmpty(attachments.value) ? [attachments.value] : undefined}
              rules={isValidators(attachments.validators)}
              render={(props) => {
                return (
                  <Uploader
                    draggable
                    autoUpload={false}
                    fileList={props.value || []}
                    disabled={disabledForm}
                    onChange={(fileList) => {
                      if (isEmpty(fileList)) {
                        props.onChange(undefined)
                      } else {
                        let files = []
                        files.push(fileList[fileList.length - 1])
                        props.onChange(files)
                      }
                    }}
                  >
                    <div>
                      <div
                        style={{ lineHeight: '50px' }}
                        className={classNames('uploader', `${theme[0]}-background`)}
                      >
                        <Icon size="4x" icon="upload2" />
                        <small className="uploder__text">
                          <p style={{ wordBreak: 'break-word' }}>
                            คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                          </p>
                        </small>
                      </div>
                    </div>
                  </Uploader>
                )
              }}
            />
          </Col>
        </Row>
      )} */}
    </>
  )
}

const attachments = {
  name: 'attachments',
  label: 'แนบไฟล์สรุปผลการพิจารณากลั่นกรอง',
  value: null,
  validators: [],
}
